/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:relative}.zoom-level[_ngcontent-%COMP%]{position:absolute;left:7px;bottom:8px;height:22px;padding:4px 4px 3px;background-color:rgb(113,113,113,30%);border-radius:3px;color:#fff;font-size:9px}#map-scaleline[_ngcontent-%COMP%]{position:absolute;left:45px;bottom:0}\n/*# sourceMappingURL=common-map.component.css.map*/"];
export { styles as styles };
